export const EmailsExternalCompanies = {
    validDomains: ['transportationamerica.com', 'mdambulance.net', 'americanambulancefl.com'],
};



// WEBPACK FOOTER //
// ./src/app/core/enums/emails-external-companies.enum.ts